import React, { useState, useCallback, useEffect } from "react";
import {  View, Alert,  Platform } from "react-native";
//import YoutubePlayer from "react-native-youtube-iframe";
import "../config/sty.css"

export default function VideoVisor({videoNumber}) {
    debugger
    useEffect(() => {
      
        setVideo(videoNumber) 

  }, [videoNumber]);
    const [ video, setVideo] =  useState([])
    
    const [playing, setPlaying] = useState(false);

  const onStateChange = useCallback((state) => {
    if (state === "ended") {
      setPlaying(false);
      Alert.alert("Terminó el video!");
    }
  }, []);

//video glándula pineal: WWzEK7NLi74&t , 
// video muestra: iee2TATGMyI
  return (
    <>
    {
    //.............................................
    //Sección que pinta videos youtube
    //.............................................
     Platform.OS === 'web' ?     
     <div>
      <div className="video-responsive">
          <iframe
            width="380"
            height="380"
            src={`https://www.youtube.com/embed/` + video}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
          />
      </div>
    </div> 
     :
     <View>
      {/* <YoutubePlayer 
        height={300}
        play={playing}
        videoId={video}
        onChangeState={onStateChange}
      />  */}
     </View>
    }
    </>
  );
}

